import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, RouterOutlet } from "@angular/router";
import { CodeInputModule } from "angular-code-input";
import { NgxPermissionsModule } from "ngx-permissions";

import { SharedModule } from "../shared/shared.module";
import { UsersModule } from "../users/users.module";

import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ActivationComponent } from "./activation/activation.component";
import { AuthenticationComponent } from "./authentication.component";
import { ForgottenPasswordComponent } from "./forgotten-password/forgotten-password.component";
import { GiftBoxComponent } from './gift-box/gift-box.component';
import { LoginComponent } from "./login/login.component";
import { NewSherpaComponent } from "./new-sherpa/new-sherpa.component";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthenticationGuardService } from "./services/authentication.guard.service";
import { AuthenticationService } from "./services/authentication.service";
import { DemandsService } from "./services/demands.service";
import { GoogleService } from "./services/google.service";
import { LoginGuardService } from "./services/login.guard.service";
import { SignupComponent } from './signup/signup.component';


@NgModule({
  declarations: [ LoginComponent, ActivationComponent, ForgottenPasswordComponent, ResetPasswordComponent, AuthenticationComponent, NewSherpaComponent, ActivateAccountComponent, SignupComponent, GiftBoxComponent ],
  providers: [ AuthenticationService,
    AuthenticationGuardService,
    LoginGuardService,
    GoogleService,
    DemandsService
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterOutlet,
    CodeInputModule,
    NgxPermissionsModule.forChild(),
    RouterModule.forChild([
        {
          path: '',
          component: AuthenticationComponent,
          children: [
            {
              path: 'activation',
              component: ActivationComponent,
            },
            {
              path: 'activate-account',
              component: ActivateAccountComponent,
            },
            {
              path: 'forgotten-password',
              component: ForgottenPasswordComponent,
            },
            {
              path: 'reset-password',
              component: ResetPasswordComponent,
            },
            {
              path: 'new-sherpa',
              component: NewSherpaComponent,
            },
          ]
        },
        {
          path: 'login',
          component: LoginComponent,
          canActivate: [ LoginGuardService ],
        },
        {
          path: 'signup',
          component: SignupComponent
        },
        {
          path: 'gift-box',
          component: GiftBoxComponent
        }
      ]
    ),
    UsersModule
  ]
})
export class AuthenticationModule {
}
